// export const baseUrl = "http://localhost:5000/api";
// export const imgBaseUrl = "http://localhost:5000";
export const baseUrl = "https://api.solebs.com/api";
export const imgBaseUrl = "https://api.solebs.com";

export const QUALITIES = [
  { value: "Premium", label: "Premium" },
  { value: "Average", label: "Average" },
  { value: "Good", label: "Good" },
  { value: "Above Average", label: "Above Average" },
  { value: "Below Average", label: "Below Average" },
  { value: "Bad", label: "Bad" },
  { value: "Invalid", label: "Invalid" },
];
export const GENDER = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
  { value: "Other / Prefer not to say", label: "Other / Prefer not to say" },
];
export const INFLUENCER_TYPE = [
  { value: "Nano", label: "Nano" },
  { value: "Micro", label: "Micro" },
  { value: "Mid Tier", label: "Mid Tier" },
  { value: "Macro", label: "Macro" },
  { value: "Mega", label: "Mega" },
  { value: "Celebrity", label: "Celebrity" },
];

export const INFLUENCER_CATEGORY = [
  { value: "Fashion", label: "Fashion" },
  { value: "Beauty", label: "Beauty" },
  { value: "Travel", label: "Travel" },
  { value: "Lifestyle", label: "Lifestyle" },
  { value: "Food", label: "Food" },
  { value: "Technology", label: "Technology" },
  { value: "Fitness", label: "Fitness" },
  { value: "Entertainment", label: "Entertainment" },
  { value: "Parenting", label: "Parenting" },
  { value: "Luxury", label: "Luxury" },
  { value: "Sports", label: "Sports" },
];

export const AVG_VIEWS = [
  { value: "Below 5k", label: "Below 5k" },
  { value: "Below 15k", label: "Below 15k" },
  { value: "15-50k", label: "15-50k" },
  { value: "Above 50k", label: "Above 50k" },
  { value: "Above 100k", label: "Above 100k" },
  { value: "Above 200k", label: "Above 200k" },
];

export const FOLLOWERS = [
  { label: "2000-10k", value: "2000-10000" },
  { label: "10k-50k", value: "10000-50000" },
  { label: "50k-200k", value: "50000-200000" },
  { label: "200k-500k", value: "200000-500000" },
  { label: "500k-1M", value: "500000-1000000" },
  { label: "Above 1M", value: "1000000" },
];

export const CAMPAIGN_TYPE = [
  { name: "paid", label: "Paid" },
  { name: "barter", label: "Barter" },
];

export const CAMPAIGN_STATUS = [
  { name: "On hold", label: "On Hold" },
  { name: "Active", label: "Active" },
  { name: "Completed", label: "Completed" },
  { name: "Not started yet", label: "Not Started Yet" },
];

export const APPROVAL_STATUS = [
  { name: "approved", label: "Approved" },
  { name: "rejected", label: "Rejected" },
  { name: "pending", label: "Pending" },
];
